export default "__VITE_ASSET__CDhT$G8l__"